import { render, staticRenderFns } from "./DownloadOrder.vue?vue&type=template&id=01c45b2a&scoped=true"
import script from "./DownloadOrder.vue?vue&type=script&lang=js"
export * from "./DownloadOrder.vue?vue&type=script&lang=js"
import style0 from "./DownloadOrder.vue?vue&type=style&index=0&id=01c45b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c45b2a",
  null
  
)

export default component.exports